<template>
  <div>
    <mdb-tbl hover sm>
      <mdb-tbl-head>
        <tr class="title" >
          <th>동의서</th>
          <th style="width:100px">등록일</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(a, ix) in agreements" :key="ix">
          <td ><router-link :to="{name: 'StaffAgreement', params: {_id: a._id}}" class="pointer"> {{a.title}}</router-link></td>
          <td>{{$strDate(a.regDate)}}</td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
    <div class="text-right">
      <mdb-btn icon="edit" class="py-2" @click="onNew">작성</mdb-btn>
    </div>
  </div>
</template>
<script>
import { } from 'mdbvue';
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'StaffAgreementPage',
  components: {},
  props: [],
  data: () => ({
    TAG: 'StaffAgreementPage :',
    agreements: []
  }),
  computed: {
    ...mapState('auth', ['org'])
  },
  methods: {
    async load () {
      if (!this.org || !this.org._id) return
      this.agreements = await this.$Agreement.list({ org: this.org._id })
    },
    onNew () {
      this.$router.push({ name: 'StaffAgreementEdit', params: { _id: 'new' } })
    }
  },
  watch: { org: 'load' },
  created () { this.load() }
}
</script>
